import { useCallback, useMemo } from 'react';

export const useTracking = (eventData) => {
  const getContextData = useCallback(() => {
    return eventData || {};
  }, [eventData]);

  const trackEvent = useCallback((eventPath, data = {}, eventCallback) => {
    // Mock successful event tracking
    if (eventCallback) {
      eventCallback(200, 'Success');
    }
  }, []);

  const Track = useCallback(({ children }) => {
    return children;
  }, []);

  return useMemo(
    () => ({
      Track,
      trackEvent,
      getContextData
    }),
    [Track, trackEvent, getContextData]
  );
};
